module.exports = __webpack_public_path__ + "img/searchnotfound.e2c3a75b.svg";